import React from 'react';

import {useApiSearchAdminPollSurvey} from "@/api/survey";

import TableSearch from "@/components/table/tableSearch";
import {URLS} from "@/lib/urls";
import toFaNumber from "@/lib/utils/number";
import {Button, Tag, Tooltip} from "antd";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {PlusIcon, UserIcon} from "lucide-react";
import {activeRelated} from "@/pages/admin/survey/edit/_section/SettingBlock";
import {Can} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";

function AdminSurveyListPage(props) {

    const myBreadCrumb = [
        {
            path: URLS.homepage,
            title: "خانه"
        },
        {
            path: URLS.admin.survey.dashboard,
            title: "نظرسنجی"
        },

    ]
    const columns = [
        {
            title: 'شناسه',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return <Link to={sprintf(URLS.admin.survey.edit, {id: record.id})}>{toFaNumber(text)}</Link>
            }

        },

        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => {
                return <Link to={sprintf(URLS.admin.survey.edit, {id: record.id})}>{text}</Link>
            }


        },
        {
            title: 'جنسیت / نوع',
            dataIndex: 'event',
            key: 'event',
            render: (text, record) => {
                let icon;
                let tooltipText;

                switch (record.active_gender) {
                    case 'male':
                        icon = <span className="h-4 w-4 icon-child text-blue-6"/>;
                        tooltipText = 'آقایان';
                        break;
                    case 'female':
                        icon = <span className="h-4 w-4 icon-child-dress text-pink-500"/>;
                        tooltipText = 'بانوان';
                        break;
                    case 'both':
                        icon = <><span className="h-4 w-4 icon-child text-blue-6"/><span
                            className="h-4 w-4 icon-child-dress text-pink-500"/></>;
                        tooltipText = 'هردو';
                        break;
                    default:
                        icon = <UserIcon className="h-4 w-4 text-gray-500"/>;
                        tooltipText = 'نامشخص';
                }

                return (

                    <div className="flex">
                        <Tooltip title={tooltipText}>
                            <div className="flex items-center justify-center">
                                {icon}
                            </div>
                        </Tooltip>
                        <div>
                            {text === 'certificate' ? 'گواهینامه' : 'عمومی'}
                        </div>
                    </div>
                );
            }
        },
        {
            title: 'متصل به',
            dataIndex: 'activeRelated',
            key: 'activeRelated',
            render: (text, record) => {

                const matchedItem = activeRelated.find(item => item.value === text);

                return matchedItem ? matchedItem.label : text;
            }
        },

        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                return text === 'draft' ? <Tag color="volcano">پیش نویس</Tag> : <Tag color="green">منتشر شده</Tag>
            }

        },
        {
            title: ' ',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (<Link to={sprintf(URLS.admin.survey.edit, {id: record.id})}>
                    <Button type="" size={'small'}>ویرایش</Button>
                </Link>)
            }

        },
    ];

    const addButton = <div className="flex justify-end">
        <div>
            <Can permission={PermList.SURVEY_ADD}>
                <Link to={URLS.admin.survey.create}>
                    <Button
                        icon={<PlusIcon className="h-4 w-4"/>}
                        className="flex items-center"
                        type={'dashed'}
                    >
                        افزودن نظرسنجی جدید
                    </Button>
                </Link>
            </Can>

        </div>
    </div>

    return (
        <AdminLayout pageTitle={'لیست نظرسنجی'} breadCrumb={myBreadCrumb}>


            <TableSearch apiFn={useApiSearchAdminPollSurvey}
                         searchInput={true}
                         addButton={addButton}
                         columns={columns}></TableSearch>
        </AdminLayout>
    )

}

export default AdminSurveyListPage;


